import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { NEXT_MAP, MEMBERS } from "../data/site";

export default function Footer() {
    const { pathname } = useLocation();
    const next = NEXT_MAP[pathname] || { to: "/", no: "00", label: "Back to Home" };

    useEffect(() => {
        window.__lenis?.scrollTo(0, { immediate: true });
    }, [pathname]);

    return (
        <footer className="border-t border-white/10 bg-sheet">
            <Link
                to={next.to}
                data-testid={`footer-next-link-${next.no.replace(/\./g, "-")}`}
                className="group block border-b border-white/10 hover:bg-amber/[0.04] transition-colors duration-300"
            >
                <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 sm:py-20 flex items-center justify-between gap-6">
                    <div>
                        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-amber mb-3">
                            Next file → {next.no}
                        </p>
                        <p className="font-display text-3xl sm:text-5xl text-paper group-hover:text-amber transition-colors duration-300">
                            {next.label}
                        </p>
                    </div>
                    <span className="w-12 h-12 sm:w-16 sm:h-16 rounded-full border border-white/20 flex items-center justify-center group-hover:border-amber group-hover:bg-amber transition-all duration-300 shrink-0">
                        <ArrowRight className="text-paper group-hover:text-ink transition-colors" size={22} />
                    </span>
                </div>
            </Link>
            <div className="mx-auto max-w-7xl px-5 sm:px-8 py-10 grid gap-8 sm:grid-cols-3">
                <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber mb-3">Classification</p>
                    <p className="font-mono text-[11px] leading-relaxed text-ash">
                        PUBLIC RESEARCH — compiled for COMP501: Computing Technology in Society, Semester 2 2026.
                        All figures and statistics are cited on the References page.
                    </p>
                </div>
                <div>
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber mb-3">The Group</p>
                    <ul className="font-mono text-[11px] leading-relaxed text-ash">
                        {MEMBERS.map((m) => (
                            <li key={m.name}>
                                {m.name} — {m.role}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="sm:text-right">
                    <p className="font-display text-xl text-paper">FACE INDEX</p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ash mt-2">
                        © 2026 · Aotearoa New Zealand
                    </p>
                </div>
            </div>
        </footer>
    );
}
